import { SetStateAction, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { LAYOUT_TYPE, SUCCESS_MESSAGE_TIMEOUT } from "../../constants";
import {
  createApplicationVersionSigning,
  isSigningRequestUnique,
} from "../../api/versionApi";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import CardRadioSelect from "../../components/CardRadioSelect/CardRadioSelect";
import SuccessMessage from "../../components/SuccessMessage/SuccessMessage";

export default function CreateVersionSigning() {
  const [processor, setProcessor] = useState("");
  const [environment, setEnvironment] = useState("");
  const [validated, setValidated] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const params = useParams();
  const navigate = useNavigate();

  const handleChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "processor") {
      setProcessor(value);
    }
    if (name === "environment") {
      setEnvironment(value);
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      setSubmitting(true);

      isSigningRequestUnique(
        Number(params.versionId),
        processor,
        environment,
        (responseData: SetStateAction<any>) => {
          if (responseData.unique) {
            createApplicationVersionSigning(
              Number(params.versionId),
              processor,
              environment,
              (responseData: SetStateAction<any>) => {
                setSuccess("New version signing was created.");
                setError("");
                setTimeout(() => {
                  navigate(
                    "/application/" +
                      params.applicationId +
                      "/version/" +
                      params.versionId +
                      "/signing/" +
                      responseData.id,
                    { replace: true }
                  );
                }, SUCCESS_MESSAGE_TIMEOUT);
              },
              (errorText: React.SetStateAction<string>) => {
                setSubmitting(false);
                setError(errorText);
              }
            );
          } else {
            setSubmitting(false);
            setError(
              "Active signing request for this processor and environment already exists!"
            );
          }
        },
        (errorText: React.SetStateAction<string>) => {
          setSubmitting(false);
          setError(errorText);
        }
      );
    }

    setValidated(true);
  };

  return (
    <>
      {error && (
        <ErrorMessage
          text={error}
          inContainer={true}
          containerClassName="form-container"
        />
      )}
      {success && (
        <SuccessMessage text={success} containerClassName="form-container" />
      )}
      <Layout
        type={LAYOUT_TYPE.FORM_PAGE}
        title="Submit Version Signing"
        buttons={[
          {
            title: "Cancel",
            variant: "outline-primary",
            action: () => {
              navigate(-1);
            },
            disabled: submitting,
          },
          {
            title: "Submit",
            variant: "primary",
            typeSubmit: true,
            withSpinner: true,
            disabled: submitting,
          },
        ]}
        onFormSubmit={handleSubmit}
        validated={validated}
      >
        <CardRadioSelect
          title="Select Processor"
          name="processor"
          options={[
            {
              name: "pax",
              label: "PAX",
              value: "PAX",
            },
            {
              name: "castles",
              label: "Castles",
              value: "CASTLES",
            },
            {
              name: "cvend_gen_I",
              label: "cVEND Gen I",
              value: "CVEND_GEN_I",
            },
            {
              name: "cvend_gen_II",
              label: "cVEND Gen II",
              value: "CVEND_GEN_II",
            },
          ]}
          value={processor}
          onChange={handleChange}
          requiredText="Please select processor!"
          disabled={submitting}
        />
        <CardRadioSelect
          title="Select Environment"
          name="environment"
          options={[
            {
              name: "development",
              label: "Development",
              value: "DEVELOPMENT",
              translateLabel: true,
            },
            {
              name: "staging",
              label: "Staging",
              value: "STAGING",
              translateLabel: true,
            },
            {
              name: "production",
              label: "Production",
              value: "PRODUCTION",
              translateLabel: true,
            },
          ]}
          value={environment}
          onChange={handleChange}
          requiredText="Please select environment!"
          disabled={submitting}
        />
      </Layout>
    </>
  );
}
